const NOT_ALLOWED_USER_ROLES = [];
const NOT_ALLOWED_ROLE_CATEGORIES = [];
export const onlyUserRoles = id => !NOT_ALLOWED_USER_ROLES.includes(id);
export const onlyRoleCategories = id => {
    return id === 1 || !NOT_ALLOWED_ROLE_CATEGORIES.includes(id - 1);
};